module.exports = __webpack_public_path__ + "static/media/upload_media.acc059a1.svg";